var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 8C6.66667 7.54083 7.04083 7.16667 7.5 7.16667H14.1667V13H20V13.8375C20.4951 13.4744 21.0642 13.2249 21.6667 13.1067V11.8217L15.345 5.5H7.5C6.12167 5.5 5 6.62167 5 8V25.5H12.5V23.8333H6.66667V8ZM15.8333 8.345L18.8217 11.3333H15.8333V8.345ZM24.2683 15.3992C23.3233 14.4542 21.6767 14.4542 20.7325 15.3992L14.1667 21.9642V25.5H17.7025L24.2675 18.935C24.74 18.4625 25 17.835 25 17.1667C25 16.4983 24.74 15.8708 24.2683 15.3992ZM23.0892 17.7558L17.0125 23.8333H15.8333V22.6542L21.9108 16.5775C22.0695 16.4258 22.2805 16.3411 22.5 16.3411C22.7195 16.3411 22.9305 16.4258 23.0892 16.5775C23.2467 16.7342 23.3333 16.9433 23.3333 17.1667C23.3333 17.39 23.2467 17.5983 23.0892 17.7558Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ace75ff98d92e878ae8d53ba7336b9cb.svg";
export { ForwardRef as ReactComponent };